<template>
  <el-dialog
    width="650px"
    class="withdraw-dialog"
    title="结算单确认"
    :visible.sync="openDialog"
    :destroy-on-close="true"
  >
    <div class="withdraw-dialog">
      <div class="withdraw-all-money">
        <p>待结算金额</p>
        <p class="all-money-num">
          {{ withdrawInfo.num | regroupComma(withdrawInfo.type) }}
        </p>
        <div class="line"></div>
      </div>

      <div>
        <div class="form-item">
          <span class="label-name">开户名</span>
          <p class="user-info">{{ bankInfo.name }}</p>
        </div>
        <div class="form-item">
          <span class="label-name">提现账号</span>
          <template>
            <img src="@/assets/images/icon_bank.png" />
            <p class="user-info">
              {{ bankInfo.bank_name }}（
              {{ bankInfo.bank_card | regroupBankCard }}）
            </p>
          </template>
        </div>
        <div class="form-item">
          <span class="label-name">手机号</span>
          <template>
            <el-input
              disabled
              class="input-phone input"
              :placeholder="developerInfo.phone"
              autocomplete="off"
            ></el-input>
          </template>
          <span class="error-tip">{{ errorPhoneTip }}</span>
        </div>
        <div class="form-item">
          <span class="label-name">验证码</span>
          <el-input
            class="input-code input"
            v-model="form.vercode"
            placeholder="请输入验证码"
            autocomplete="off"
            @blur="checkCode"
          ></el-input>
          <span
            class="btn-get-code btn"
            :class="{ 'btn-forbid': isDisabled }"
            @click="getCode"
            >{{ codeTxt }}</span
          >
          <span class="error-tip">{{ errorCodeTip }}</span>
        </div>
        <div class="form-item" v-if="Number(developerInfo.sec_pw) === 1">
          <span class="label-name">二级密码</span>
          <el-input
            class="input-password input"
            v-model="form.sec_pw"
            type="password"
            placeholder="请输入二级密码"
            autocomplete="off"
            show-password
          ></el-input>
        </div>
        <div class="dialog-footer">
          <div class="btn-confirm btn" @click="submitApply">确认</div>
          <p>由于扣税及手续费等因素，请以实际到账金额为准</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { checkoutPhone, checkoutCode } from '../../checkoutReg';
import { withdraw } from '@/api/income';
import { getVercode } from '@/api/common';
import { encryptPwd } from '@/utils/crypto';
import { mapState } from 'vuex';
import {
  ensureSecuritySensitiveVerify,
  isSecurityVerifyCancelled,
} from '@/utils/securitySensitiveVerify';
export default {
  name: 'withdrawForm',
  props: {
    withdrawInfo: {
      type: Object,
      default: () => {},
    },
    showWithdrawForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDialog: false,
      form: {
        phone: '',
        money: '',
        vercode: '',
        sec_pw: '',
      },
      isDisabled: false,
      codeTxt: '获取验证码',
      errorMoneyTip: '',
      errorPhoneTip: '',
      errorCodeTip: '',
    };
  },
  computed: {
    ...mapState(['developerInfo', 'bankInfo', 'userInfo']),
  },
  filters: {
    regroupBankCard(val) {
      if (val) {
        return val.substring(val.length - 4);
      }
    },
    regroupComma(val, type) {
      if (val != undefined) {
        if (val.toString().includes('.')) {
          let reg = /(\d)(?=(\d{3})+\.)/g;
          let point = '';
          type == 1 ? (point = 2) : (point = 2);
          return val.toFixed(point).toString().replace(reg, '$1,');
        } else {
          let reg = /(\d)(?=(?:\d{3})+$)/g;
          return val.toString().replace(reg, '$1,');
        }
      }
    },
  },
  created() {
    this.openDialog = this.showWithdrawForm;
  },
  watch: {
    'withdrawInfo.type'() {
      Object.assign(this.$data, this.$options.data());
    },
    showWithdrawForm(val) {
      this.openDialog = val;
    },
    openDialog(val) {
      if (!val) {
        this.$emit('closeWithdrawForm', false);
      }
    },
  },
  methods: {
    // 获取公共验证码接口
    async fetchGetVercode(phone) {
      try {
        await getVercode({ phone, tk: this.userInfo.tk });
        this.$message.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    changeDialog() {
      this.openDialog = false;
    },
    // 提现接口
    async fetchWithdraw(data) {
      try {
        await withdraw(data);
        this.$message.success('已成功发起申请');
        this.$emit('closeWithdrawForm', false, 'refresh');
      } catch (error) {
        console.log(error);
      }
    },
    checkPhone(phone) {
      this.errorPhoneTip = checkoutPhone(phone);
    },
    checkCode() {
      this.errorCodeTip = checkoutCode(this.form.vercode);
    },
    // 提现
    async submitApply() {
      this.checkCode();
      if (
        this.errorCodeTip ||
        (Number(this.developerInfo.sec_pw) === 1 && !this.form.sec_pw)
      ) {
        if (Number(this.developerInfo.sec_pw) === 1 && !this.form.sec_pw) {
          this.$message.error('请输入二级密码');
        }
        return;
      }

      const data = {
        money_type: 1,
        money: this.withdrawInfo.num,
        vercode: this.form.vercode,
      };
      if (Number(this.developerInfo.sec_pw) === 1) {
        data.sec_pw = encryptPwd(this.form.sec_pw);
      }
      this.fetchWithdraw(data);
    },
    // 获取验证码
    getCode() {
      // let phone = '';
      // if (this.withdrawInfo.type == 2) {
      //   phone = this.developerInfo.phone;
      // } else {
      //   phone = this.bankInfo.phone;
      // }
      // 统一用开发者手机
      this.checkPhone(this.developerInfo.phone);
      if (!this.errorPhoneTip) {
        this.fetchGetVercode(this.developerInfo.phone);
      }
    },
    // 倒计时
    countDown() {
      let time = 60;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '获取验证码';
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.withdraw-dialog {
  .withdraw-all-money {
    text-align: center;
    font-size: 14px;
    .all-money-num {
      color: $--color-primary;
      font-size: 40px;
      line-height: 1;
      margin: 12px 0 25px;
    }
    .line {
      width: 80%;
      height: 1px;
      background: #d9d9d9;
      margin: 0 auto;
      margin-bottom: 39px;
    }
  }
  .form-item {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    .label-name {
      font-size: 16px;
      width: 120px;
      text-align: right;
      margin-right: 40px;
    }
    img {
      margin-right: 9px;
    }
    .el-input {
      width: 260px;
      height: 40px;
    }
    .input-code {
      width: 140px;
      margin-right: 10px;
    }
    .btn-get-code {
      display: inline-block;
      width: 110px;
      height: 32px;
      background: $--color-primary;
      border-radius: 8px;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
    }
    .error-tip {
      color: #f7424e;
      margin-left: 26px;
    }
  }
  .user-info {
    font-size: 16px;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  .dialog-footer {
    margin-top: 56px;
    .btn-confirm {
      width: 200px;
      height: 50px;
      color: #ffffff;
      font-size: 20px;
      border-radius: 8px;
      background: $--color-primary;
      margin: 0 auto;
      line-height: 50px;
      text-align: center;
      margin-bottom: 50px;
    }
    p {
      width: 100%;
      text-align: center;
    }
  }

  ::v-deep .el-dialog__title {
    font-size: 24px;
    color: #595959;
  }
}
.btn {
  cursor: pointer;
  &:hover {
    filter: brightness(105%);
  }
}
.btn-forbid {
  cursor: not-allowed;
  background: #d9d9d9 !important;
  &:hover {
    filter: brightness(100%);
  }
}
</style>
